import { Dialog, Pane, Text } from 'evergreen-ui';

export default function TurniDropTypeDialog({ isOpen, onClose, pendingDropData, onDropAsTurno, onDropAsFerie, onDropAsRep }) {
  return (
    <Dialog isShown={isOpen} title="Cosa vuoi inserire?" onCloseComplete={onClose} hasFooter={false} width={380}>
      <Pane paddingBottom={20}>
        <Pane background="tint2" borderRadius={6} padding={10} marginBottom={16} display="flex" alignItems="center" gap={8}>
          <Text size={300} color="muted">Collaboratore:</Text>
          <Text size={400} fontWeight={600}>{pendingDropData.name}</Text>
          <Text size={300} color="muted">—</Text>
          <Text size={300} color="muted">{pendingDropData.date}</Text>
        </Pane>
        <Pane display="flex" flexDirection="column" gap={8}>
          <Pane
            display="flex" alignItems="center" gap={12} padding={14}
            border="default" borderRadius={6} cursor="pointer" hoverElevation={1}
            onClick={onDropAsTurno} background="white"
          >
            <Text fontSize={22}>🕐</Text>
            <Pane>
              <Text display="block" fontWeight={600}>Turno</Text>
              <Text size={300} color="muted">Inserisci un turno lavorativo</Text>
            </Pane>
          </Pane>
          <Pane
            display="flex" alignItems="center" gap={12} padding={14}
            border="default" borderRadius={6} cursor="pointer" hoverElevation={1}
            onClick={onDropAsFerie} background="white"
          >
            <Text fontSize={22}>📋</Text>
            <Pane>
              <Text display="block" fontWeight={600}>Ferie / Permesso / Malattia</Text>
              <Text size={300} color="muted">Registra un'assenza</Text>
            </Pane>
          </Pane>
          <Pane
            display="flex" alignItems="center" gap={12} padding={14}
            border="default" borderRadius={6} cursor="pointer" hoverElevation={1}
            onClick={onDropAsRep} background="white"
          >
            <Text fontSize={22}>📞</Text>
            <Pane>
              <Text display="block" fontWeight={600}>Reperibilità</Text>
              <Text size={300} color="muted">Inserisci una reperibilità</Text>
            </Pane>
          </Pane>
        </Pane>
      </Pane>
    </Dialog>
  );
}
